import { TFunction } from 'i18next'
import Overview from './Overview'
import Clicks from './Clicks'
import Conversions from './Conversions'
import Commissions from './Commissions'
import PendingInvoices from './PendingInvoices'
import Payouts from './Payouts'
import Policies from './Policies'
import { Affiliate } from '../../types'

interface TabsProps {
    t: TFunction
    affiliate?: Affiliate
    affiliateId: number
    refetch: () => void
    policyModalOpen: boolean
    setPolicyModalOpen: (open: boolean) => void
}

export const tabs = ({
    t,
    affiliate,
    affiliateId,
    refetch,
    policyModalOpen,
    setPolicyModalOpen,
}: TabsProps) => [
    {
        label: t('overview'),
        value: 'overview',
        component: <Overview affiliate={affiliate} refetch={refetch} />,
    },
    {
        label: t('clicks'),
        value: 'clicks',
        component: <Clicks affiliateId={affiliateId} />,
    },
    {
        label: t('signup_conversions'),
        value: 'conversions',
        component: <Conversions affiliateId={affiliateId} />,
    },
    {
        label: t('commissions'),
        value: 'commissions',
        component: <Commissions affiliateId={affiliateId} />,
    },
    {
        label: t('pending_invoices'),
        value: 'pending-invoices',
        component: <PendingInvoices affiliateId={affiliateId} />,
    },
    {
        label: t('payouts'),
        value: 'payouts',
        component: <Payouts affiliateId={affiliateId} />,
    },
    {
        label: t('commission_policies'),
        value: 'policies',
        component: (
            <Policies
                affiliateId={affiliateId}
                modalOpen={policyModalOpen}
                setModalOpen={setPolicyModalOpen}
            />
        ),
    },
]
